

  

  <div class="wrapper card-background-unsupport">
    <div class="Oval">
      <img id="img-unsupported" class="width-120" alt="" src="./assets/images/problem.PNG">
    </div>
    <div>
      <h1 *ngIf="errorType==='browser'" class="margin-top-60" [innerHTML]="contentDataunsupportedBrowser['header']">
      </h1>
      <h1 *ngIf="errorType==='resolution'" class="margin-top-60" [innerHTML]="contentDataunsupportedResolution['header']">
      </h1>
    </div>
    
     

    <div class="content-wrapper margin-top-60">
      <p *ngIf="errorType==='browser'" class="content-top margin-both" id="unsupported-introduction"
      [innerHTML]="contentDataunsupportedBrowser['Detail']">
      </p>
      <p *ngIf="errorType==='resolution'" class="content-top margin-both" id="unsupported-introduction"
      [innerHTML]="contentDataunsupportedResolution['Detail']">
      </p>
    </div> 

   
  </div>

